module.exports = __webpack_public_path__ + "img/02_img.b1b9acea.png";